var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "note 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.7636 0H4.23653C2.76995 0 1.58105 1.1889 1.58105 2.65547V15.3445C1.58105 16.8111 2.76995 18 4.23653 18H13.7636C15.2301 18 16.419 16.8111 16.419 15.3445V2.65547C16.419 1.1889 15.2301 0 13.7636 0ZM6.80618 5.02294H11.1939C11.5323 5.02266 11.8069 5.29682 11.8071 5.63526C11.8074 5.97369 11.5333 6.2483 11.1948 6.24854C11.1945 6.24854 11.1942 6.24854 11.1939 6.24854H6.80618C6.46775 6.24854 6.19338 5.97417 6.19338 5.63574C6.19338 5.2973 6.46775 5.02294 6.80618 5.02294ZM12.7729 12.9771H5.22722C4.88879 12.9771 4.61442 12.7027 4.61442 12.3643C4.61442 12.0259 4.88879 11.7515 5.22722 11.7515H12.7729C13.1113 11.7515 13.3857 12.0259 13.3857 12.3643C13.3857 12.7027 13.1113 12.9771 12.7729 12.9771ZM12.7729 9.6128H5.22722C4.88879 9.6128 4.61442 9.33844 4.61442 9C4.61442 8.66156 4.88879 8.3872 5.22722 8.3872H12.7729C13.1113 8.3872 13.3857 8.66156 13.3857 9C13.3857 9.33844 13.1113 9.6128 12.7729 9.6128Z",
    fill: "#88C3E1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteSvg);
export default __webpack_public_path__ + "static/media/NoteSvg.8484f14a1a8308634c2697af0630e389.svg";
export { ForwardRef as ReactComponent };